module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_j_normal.e6e0fd47.png";